import emailMisspelled, { all } from "email-misspelled";
import { EmailContentFlow, Locales } from "../enums";
import { getTextColorOfHexColor } from "./colors";
const isDomainInall = (domain) => {
    return all.some((allDomain) => {
        return domain.includes(allDomain);
    });
};
export const getWebsiteFromEmail = (email) => {
    const domainName = email.split("@").pop();
    if (domainName && isDomainInall(domainName)) {
        return null;
    }
    return domainName || null;
};
export const isEmailMisspelled = (email) => {
    const emailChecker = emailMisspelled({ domains: all });
    return emailChecker(email);
};
const mirrorLinkText = {
    [Locales.EN]: "View in browser",
    [Locales.FR]: "Voir dans le navigateur",
    [Locales.ES]: "Ver en el navegador",
};
export const getEmailBodyHtml = ({ body, backgroundColor, mirrorLink, locale, }) => {
    const hasBackground = !!backgroundColor;
    const wrapperBackgroundColor = backgroundColor ?? "#F9F9F9";
    const bodyBackgroundColor = backgroundColor ?? "#FFFFFF";
    // Determine mirror link color based on background luminance
    const mirrorLinkColor = backgroundColor ? getTextColorOfHexColor(backgroundColor) : "black";
    const mirrorLinkHtml = mirrorLink
        ? `
    <div style="text-align: center; padding: 8px 0 16px 0; font-family: Arial, sans-serif; font-size: 12px;">
      <a href="${mirrorLink}" style="color: ${mirrorLinkColor}; text-decoration: underline;">
        ${mirrorLinkText[locale]}
      </a>
    </div>
  `
        : "";
    return `
<div style="background-color: ${wrapperBackgroundColor}; padding: 18px 0;">
<table width="100%" role="content-container" align="center" cellpadding="0" cellspacing="0" border="0">
  <tr>
    <td width="100%">
      <table width="100%" cellpadding="0" cellspacing="0" border="0">
        <tr>
          <td>
            <table width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%; max-width:650px;" align="center">
              <tr>
                <td style="${!hasBackground ? "border-radius: 8px;" : ""} padding:18px 14px 18px 14px; line-height:22px; text-align:inherit; background-color: ${bodyBackgroundColor};" role="module-content">
                  ${mirrorLinkHtml}
                  <div style="${hasBackground ? "border-radius: 8px;" : ""} box-sizing: border-box ; padding-top: 0px ; padding-right: 0px ; padding-bottom: 0px ; padding-left: 0px ; margin-top: 0px ; margin-right: 0px ; margin-bottom: 0px ; margin-left: 0px ; font-style: inherit ; font-weight: inherit ; font-stretch: inherit ; line-height: inherit ; font-size: 14px ; vertical-align: baseline ; border-top-width: 0px ; border-right-width: 0px ; border-bottom-width: 0px ; border-left-width: 0px ; color: #3c4858 ; letter-spacing: normal ; text-indent: 0px ; text-transform: none ; white-space: normal ; word-spacing: 0px ; background-color: rgb(255 , 255 , 255) ; float: none ; display: inline ; font-family: &quot;arial&quot; , &quot;helvetica&quot; , sans-serif">
                    ${body}
                  </div>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
</div>`;
};
const footerText = {
    [Locales.EN]: {
        sentWith: "Sent with Zeffy",
        description: "The only 100% free fundraising suite in North America.",
        learnMore: "Learn more about Zeffy",
        unsubscribe: "Unsubscribe from these emails",
    },
    [Locales.FR]: {
        sentWith: "Envoyé avec Zeffy",
        description: "La seule plateforme de collecte de fonds 100 % gratuite pour les OBNL.",
        learnMore: "En savoir plus sur Zeffy",
        unsubscribe: "Vous désabonner de ces courriels",
    },
    [Locales.ES]: {
        sentWith: "Enviado con Zeffy",
        description: "La única plataforma de recaudación de fondos 100% gratuita para ONG.",
        learnMore: "Más información sobre Zeffy",
        unsubscribe: "Desuscribirse de estos correos",
    },
};
export const getEmailFooterHtml = ({ flow, locale, frontendUrl, unsubscribeUrl, }) => {
    const { sentWith, description, learnMore, unsubscribe } = footerText[locale];
    return `
    <div style="
      background-color: #F9F9F9;
      font-family: Arial, sans-serif;
      font-size: 12px;
      color: #666;
      text-align: center;
      padding-top: 20px;
      padding-bottom: 20px;
      line-height: 1.5;
      ${flow === EmailContentFlow.Builder ? "max-width: 500px; margin: 0 auto;" : ""}
    ">
      <p style="margin: 0 0 8px 0; font-weight: bold;">${sentWith}</p>
      <p style="margin: 0 0 8px 0;">${description}</p>
      <p style="margin: 0 0 8px 0;">
        <a 
          href="${frontendUrl}/" 
          style="color: #0066cc; text-decoration: underline;"
        >${learnMore}</a>
      </p>
      <p style="margin: 0;">
        <a 
          href="${unsubscribeUrl}" 
          style="color: #0066cc; text-decoration: underline;"
        >${unsubscribe}</a>
      </p>
    </div>
  `;
};
